<template>
  <v-container>

    <v-card>
      <v-tabs
        v-model="tab"
        background-color="primary"
        dark
      >
        <v-tab
          v-for="lesson in allLessons"
          :key="lesson.title"
        >
          {{ lesson.title }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="lesson in allLessons"
          :key="lesson.lessonEditor"
        >
          <v-card flat>
            <v-card-text v-html="lesson.lessonEditor"></v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- <v-slide-y-transition mode="out-in">
      <v-layout column justify-center mb-5>
        
        <v-card v-for="(lesson, index) in unlockedLessons" class="rounded-card elevation-3 pa-3 ma-3">
          <v-card-title class="headline">{{lesson.title}}</v-card-title>
          <v-card-text v-html="lesson.lessonEditor"></v-card-text>
        </v-card>
      </v-layout>
    </v-slide-y-transition> -->
  </v-container>
</template>


<script>
export default {
  name: "Lessons",
  data: function () {
    return {
      unlockedLessons: this.$store.state.lessons.slice(0,this.$store.state.user.currentLesson),
      allLessons: this.$store.state.lessons
      // maxLesson:this.$store.state.user.currentLesson,
    };
  }
};
</script>
<script>
export default {
    data () {
      return {
        unlockedLessons: this.$store.state.lessons.slice(0,this.$store.state.user.currentLesson),
        allLessons: this.$store.state.lessons,
        tab: null,
        items: [
          { tab: 'One', content: 'Tab 1 Content' },
          { tab: 'Two', content: 'Tab 2 Content' },
          { tab: 'Three', content: 'Tab 3 Content' },
          { tab: 'Four', content: 'Tab 4 Content' },
        ],
      }
    },
  };
</script>


<style>
.rounded-card {
  border-radius: 10px;
}
</style>
